import { render, staticRenderFns } from "./PrivacyView.vue?vue&type=template&id=fd338ed2&scoped=true"
import script from "./PrivacyView.vue?vue&type=script&lang=js"
export * from "./PrivacyView.vue?vue&type=script&lang=js"
import style0 from "./PrivacyView.vue?vue&type=style&index=0&id=fd338ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd338ed2",
  null
  
)

export default component.exports